export const CANVAS_SIZE = 10000;
export const CANVAS_CENTER = CANVAS_SIZE / 2;
export const NODE_WIDTH = 260;
export const NODE_CENTER = NODE_WIDTH / 2;
export const NODE_POSITION_OFFSET_X = NODE_CENTER;
